import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import { DataResponse, SegmentGroupComparisonResponseDataSchema } from "schema"
import z from "zod"

type Response = DataResponse<z.infer<typeof SegmentGroupComparisonResponseDataSchema>>

type Options = {
  id: string
  compareId: string
  onSuccess?: (data: z.infer<typeof SegmentGroupComparisonResponseDataSchema>) => void
  enabled?: boolean
}

function getSegmentGroupCompareQueryKey(id: string, compareId: string) {
  return ["segment-group-compare", id, compareId]
}

export function segmentGroupCompareQuery({ id, compareId, onSuccess, enabled }: Options) {
  return queryOptions({
    queryKey: getSegmentGroupCompareQueryKey(id, compareId),
    queryFn: async (): Promise<z.infer<typeof SegmentGroupComparisonResponseDataSchema>> => {
      const response = await axios.get<Response>(`/segments/groups/${id}/compare/${compareId}`)

      onSuccess?.(response.data.data)

      return response.data.data
    },
    enabled,
  })
}
